module.exports = __webpack_public_path__ + "img/photo_20230127_01.d7a62d56.jpg";